import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Card,
  CardContent,
  Typography,
  Alert,
  CircularProgress,
  Paper,
  Grid,
  Chip,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Divider,
} from "@mui/material";
import {
  CloudUpload as CloudUploadIcon,
  Delete as DeleteIcon,
  CheckCircle as CheckCircleIcon,
  Error as ErrorIcon,
  Person as PersonIcon,
  AttachFile as AttachFileIcon,
  Add as AddIcon,
  ArrowLeft,
} from "@mui/icons-material";
import Gateway from "../../Utils/Api/Gateway";
import Urls from "../../Utils//index";

const { TAM_URL } = Urls;
// const TAM_URL = "https://onedotzero.employwise-sandbox.in/face-recognition";
const EmployeeForm = ({ onClose }) => {
  const [employeeCode, setEmployeeCode] = useState("");
  const [employeeDetails, setEmployeeDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // File upload states
  const [selectedFiles, setSelectedFiles] = useState([]); // Array to store all selected files
  const [uploading, setUploading] = useState(false);
  const [uploadAttempts, setUploadAttempts] = useState(0);
  const [uploadHistory, setUploadHistory] = useState([]);
  const [uploadStatus, setUploadStatus] = useState("");
  const [uploadComplete, setUploadComplete] = useState(false);
  const [lastUploadFailed, setLastUploadFailed] = useState(false);
  const [canAddNextFile, setCanAddNextFile] = useState(false);
  const [success, setSuccess] = useState(false);
  const MAX_UPLOAD_ATTEMPTS = 3;

  // Mock employee data - replace with actual API call
  const mockEmployeeData = {
    EMP001: {
      name: "John Doe",
      department: "Engineering",
      position: "Senior Developer",
      email: "john.doe@company.com",
      phone: "+1-555-0123",
      joinDate: "2020-01-15",
    },
    EMP002: {
      name: "Jane Smith",
      department: "Marketing",
      position: "Marketing Manager",
      email: "jane.smith@company.com",
      phone: "+1-555-0456",
      joinDate: "2019-03-20",
    },
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setEmployeeDetails(null);

    // Reset upload states when searching for new employee
    resetUploadState();

    try {
      // Simulate API call delay
      // await new Promise((resolve) => setTimeout(resolve, 1000));
      // const response = await Gateway({
      //   url: "/tam/employee/getData?empCode=",
      //   payload: {},
      //   type: "GET",
      // });
      // https://onedotzero.employwise-sandbox.in/face-recognition
      // Mock API call - replace with actual endpoint
      // const employee = mockEmployeeData[employeeCode.toUpperCase()];
      const employee = await Gateway({
        url: TAM_URL + "face-recognition/tam/employee/getData?empCode=" + employeeCode,
        type: "GET",
      });
      // if(employee?.data){

      // }

      console.log("EMPLOYEE", employee);
      if (employee) {
        setEmployeeDetails({
          name: employee?.user_name,
          department: "",
          position: employee?.role,
          email: employee?.email,
          phone: employee?.work_phone,
          joinDate: employee?.doj,
          removeForm: true,
        });
      }

      // if (employee) {
      //   setEmployeeDetails(employee);
      // } else {
      //   setError("Employee not found. Please check the employee code.");
      // }
    } catch (err) {
      console.log("ERROIR: ", err.response.data);

      setError(
        err.response?.data?.message || "Failed to fetch employee details. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const resetUploadState = () => {
    setSelectedFiles([]);
    setUploading(false);
    setUploadAttempts(0);
    setUploadHistory([]);
    setUploadStatus("");
    setUploadComplete(false);
    setLastUploadFailed(false);
    setCanAddNextFile(false);
  };

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    const files = event.target.files;

    if (!files?.length) {
      setUploadStatus("Files not selected");
      event.target.value = "";

      return;
    }
    if (files.length + selectedFiles.length > 5) {
      setUploadStatus("Not more than 5 images can be uploaded");
      event.target.value = "";

      return;
    }
    // if (file) {

    // }
    const arr = [];
    for (const file of files) {
      const newFile = {
        file: file,
        id: Date.now(),
        name: file.name,
        size: file.size,
        addedAt: new Date().toLocaleTimeString(),
      };
      if (!file.type.startsWith("image/")) {
        alert("Only image files are allowed.");
        return;
      }

      // Check if file size is less than or equal to 4MB
      const maxSizeInBytes = 4 * 1024 * 1024; // 4MB
      if (file.size > maxSizeInBytes) {
        alert("File size should not exceed 4MB.");
        return;
      }
      console.log("SIZE: ", newFile.size);

      arr.push(newFile);
      // Reset after adding new file
    }
    setSelectedFiles((prev) => [...prev, ...arr]);
    setUploadStatus("");
    // setCanAddNextFile(false);
  };

  const removeFile = (fileId) => {
    setSelectedFiles((prev) => prev.filter((f) => f.id !== fileId));
  };

  // Convert file to base64
  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        // Remove the data:image/jpeg;base64, prefix
        const base64 = reader.result.split(",")[1];
        resolve(base64);
      };
      reader.onerror = (error) => reject(error);
    });
  };

  const uploadFiles = async () => {
    if (selectedFiles.length === 0) return;

    setUploading(true);
    const newAttempt = uploadAttempts + 1;
    setUploadAttempts(newAttempt);

    try {
      // Create FormData with all files up to current attempt (incremental)
      const formData = new FormData();
      // const filesToUpload = selectedFiles.slice(0, newAttempt);
      const filesToUpload = [...selectedFiles];
      // Convert each file to base64 and add to FormData
      for (let i = 0; i < filesToUpload.length; i++) {
        const file = filesToUpload[i].file;
        // const base64Data = await fileToBase64(file);
        formData.append("ImageBase64", file);
      }

      const result = await Gateway({
        url: TAM_URL + "face-recognition/tam/image/register?EmpCode=" + employeeCode,
        payload: formData,
        config: {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      });
      console.log("RESULT: ", result);

      if (result?.success === "1") {
        // onClose();
        setEmployeeDetails(null);
        resetUploadState();
        setEmployeeCode("");
        setSuccess(true);
        return;
      }
      setUploadStatus("Something went wrong, try after sometime!");
    } catch (error) {
      // console.log("ERROR is: ",err);
      if (error?.response?.data?.message) {
        setUploadStatus(error.response.data.message);
      } else {
        setUploadStatus("Something went wrong, try after sometime!");
      }
    } finally {
      setUploading(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 800, mx: "auto", p: 3, maxHeight: 700, overflow: "auto" }}>
      <Typography variant="h4" gutterBottom sx={{ mb: 3 }}></Typography>
      {success && <Alert onClose={()=>setSuccess(false)}>Uploaded Successfully!</Alert>}
      {/* Employee Code Form */}
      {!Boolean(employeeDetails) ? (
        <Card sx={{ mb: 3 }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Employee Lookup
            </Typography>

            <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={8}>
                  <TextField
                    fullWidth
                    label="Employee Code"
                    value={employeeCode}
                    onChange={(e) => setEmployeeCode(e.target.value)}
                    required
                    disabled={loading}
                    placeholder="Enter employee code (e.g., EMP001)"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Button
                    type="submit"
                    variant="contained"
                    fullWidth
                    disabled={loading || !employeeCode.trim()}
                    startIcon={loading ? <CircularProgress size={20} /> : <PersonIcon />}
                  >
                    {loading ? "Searching..." : "Search"}
                  </Button>
                </Grid>
              </Grid>
            </Box>

            {error && (
              <Alert severity="error" sx={{ mt: 2 }}>
                {error}
              </Alert>
            )}
          </CardContent>
        </Card>
      ) : (
        <Button startIcon={<ArrowLeft />} onClick={() => setEmployeeDetails(null)}>
          Back
        </Button>
      )}

      {/* Employee Details */}
      {employeeDetails && (
        <Card sx={{ mb: 3 }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Employee Details
            </Typography>

            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography variant="body2" color="text.secondary">
                  Name
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  {employeeDetails.name}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body2" color="text.secondary">
                  Department
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  {employeeDetails.department}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body2" color="text.secondary">
                  Position
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  {employeeDetails.position}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body2" color="text.secondary">
                  Email
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  {employeeDetails.email}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body2" color="text.secondary">
                  Phone
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  {employeeDetails.phone}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body2" color="text.secondary">
                  Join Date
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  {employeeDetails.joinDate}
                </Typography>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      )}

      {/* File Upload Section */}
      {employeeDetails && (
        <Card>
          <CardContent>
            {/* <Typography variant="h6" gutterBottom>
              File Upload - Sequential with Incremental Retry
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Upload files one by one. You can only add the next file after the previous upload fails:
              <br />
              • Attempt 1: Upload file 1
              <br />
              • If failed → Add file 2, Attempt 2: Upload files 1 + 2
              <br />
              • If failed → Add file 3, Attempt 3: Upload files 1 + 2 + 3
            </Typography> */}

            {/* File Selection Status */}
            {/* <Alert 
              severity={canAddNextFile ? "warning" : selectedFiles.length === 0 ? "info" : "success"}
              sx={{ mb: 2 }}
            >
              {getFileSelectionMessage()}
            </Alert> */}

            {/* Upload Status */}

            {/* Current Upload Progress */}
            {/* {uploadAttempts > 0 && (
              <Box sx={{ mb: 2 }}>
                <Typography variant="body2" color="text.secondary">
                  Upload Attempts: {uploadAttempts}/{MAX_UPLOAD_ATTEMPTS}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                  Next attempt will upload: {Math.min(uploadAttempts + 1, selectedFiles.length)}{" "}
                  file(s)
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
                  {[...Array(MAX_UPLOAD_ATTEMPTS)].map((_, index) => (
                    <Box
                      key={index}
                      sx={{
                        width: 12,
                        height: 12,
                        borderRadius: "50%",
                        backgroundColor:
                          index < uploadAttempts
                            ? uploadHistory[index]?.status === "success"
                              ? "success.main"
                              : "error.main"
                            : "grey.300",
                      }}
                    />
                  ))}
                </Box>
              </Box>
            )} */}

            {/* File Selection and Upload Controls */}
            <Box sx={{ mb: 3 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <input
                    accept="image/*"
                    style={{ display: "none" }}
                    id="file-upload"
                    type="file"
                    onChange={handleFileSelect}
                    multiple
                    // disabled={!canSelectFile()}
                    disabled={selectedFiles.length >= 5}
                  />
                  <label htmlFor="file-upload">
                    <Button
                      variant="outlined"
                      component="span"
                      fullWidth
                      startIcon={selectedFiles.length === 0 ? <AttachFileIcon /> : <AddIcon />}
                      // disabled={!canSelectFile()}
                      disabled={selectedFiles.length >= 5}
                      color={canAddNextFile ? "warning" : "primary"}
                    >
                      {selectedFiles.length === 0 ? "Select Images" : `Add Images `}
                    </Button>
                  </label>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Button
                    variant="contained"
                    fullWidth
                    onClick={uploadFiles}
                    disabled={selectedFiles?.length === 0}
                    startIcon={uploading ? <CircularProgress size={20} /> : <CloudUploadIcon />}
                  >
                    {uploading ? "Uploading..." : `Upload Image(s)`}
                  </Button>
                </Grid>
              </Grid>
            </Box>

            {/* Selected Files Display */}
            {selectedFiles.length > 0 && (
              <Paper variant="outlined" sx={{ mb: 2 }}>
                <Box sx={{ p: 2, borderBottom: 1, borderColor: "divider" }}>
                  <Typography variant="h6">Selected Files ({selectedFiles.length})</Typography>
                </Box>
                <List>
                  {selectedFiles.map((fileObj, index) => (
                    <ListItem key={fileObj.id}>
                      <Box sx={{ mr: 2 }}>
                        <AttachFileIcon color="primary" />
                      </Box>
                      <ListItemText
                        primary={fileObj.name}
                        secondary={
                          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
                            <Chip label={`File ${index + 1}`} size="small" color="primary" />
                            <Typography variant="caption">
                              {(fileObj.size / 1024).toFixed(1)} KB
                            </Typography>
                            <Typography variant="caption">Added: {fileObj.addedAt}</Typography>
                            {/* {index < uploadAttempts && (
                              <Chip label="Will be uploaded" size="small" color="warning" />
                            )} */}
                          </Box>
                        }
                      />
                      <ListItemSecondaryAction>
                        <IconButton
                          edge="end"
                          onClick={() => removeFile(fileObj.id)}
                          disabled={uploading}
                          color="error"
                        >
                          <DeleteIcon />
                        </IconButton>
                      </ListItemSecondaryAction>
                    </ListItem>
                  ))}
                </List>
              </Paper>
            )}
            {uploadStatus && (
              <Alert
                severity={
                  uploadComplete && uploadHistory.some((h) => h.status === "success")
                    ? "success"
                    : "error"
                }
                sx={{ mb: 2 }}
                onClose={() => setUploadStatus("")}
              >
                {uploadStatus}
              </Alert>
            )}
            {/* Upload History */}
            {/* {uploadHistory.length > 0 && (
              <Paper variant="outlined" sx={{ mt: 2 }}>
                <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
                  <Typography variant="h6">Upload History</Typography>
                </Box>
                <List>
                  {uploadHistory.map((record, index) => (
                    <ListItem key={index}>
                      <Box sx={{ mr: 2 }}>
                        {getStatusIcon(record.status)}
                      </Box>
                      <ListItemText
                        primary={`Attempt ${record.attempt} - ${record.fileCount} file(s)`}
                        secondary={
                          <Box sx={{ mt: 1 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                              <Chip
                                label={record.status}
                                size="small"
                                color={getStatusColor(record.status)}
                              />
                              <Typography variant="caption">
                                {record.timestamp}
                              </Typography>
                            </Box>
                            <Typography variant="body2" color="text.secondary">
                              Files uploaded: {record.filesUploaded.map(f => f.name).join(', ')}
                            </Typography>
                            {record.error && (
                              <Typography variant="caption" color="error">
                                Error: {record.error}
                              </Typography>
                            )}
                          </Box>
                        }
                      />
                    </ListItem>
                  ))}
                </List>
              </Paper>
            )} */}

            {/* Empty State */}
            {/* {selectedFiles.length === 0 && uploadHistory.length === 0 && (
              <Paper
                variant="outlined"
                sx={{
                  p: 4,
                  textAlign: 'center',
                  backgroundColor: 'grey.50',
                  border: '2px dashed',
                  borderColor: 'grey.300'
                }}
              >
                <CloudUploadIcon sx={{ fontSize: 48, color: 'grey.400', mb: 2 }} />
                <Typography variant="body1" color="text.secondary">
                  No files selected
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Click "Select First File" to start the upload process
                </Typography>
              </Paper>
            )} */}

            {/* Upload Complete Message */}
            {/* {uploadComplete && (
              <Box sx={{ mt: 2, textAlign: 'center' }}>
                <Divider sx={{ mb: 2 }} />
                <Button
                  variant="outlined"
                  onClick={resetUploadState}
                  sx={{ mt: 1 }}
                >
                  Start New Upload Session
                </Button>
              </Box>
            )} */}
          </CardContent>
        </Card>
      )}
    </Box>
  );
};

export default EmployeeForm;
